import type { SVGProps } from "react";

export function EventIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.33382 4.16659H5.00049M4.16715 3.33325V4.99992M9.58382 3.33325L9.16716 4.99992M15.0005 4.16659H16.6672M15.8338 3.33325V4.99992M12.5005 7.49992L11.6672 8.33325M15.0005 10.8333L16.6672 10.4166M15.0005 15.8333H16.6672M15.8338 14.9999V16.6666M11.6672 13.7649L6.23549 8.33325L2.57715 16.3166C2.50485 16.4716 2.48199 16.6451 2.51167 16.8135C2.54136 16.982 2.62216 17.1372 2.7431 17.2581C2.86404 17.3791 3.01927 17.4599 3.18771 17.4896C3.35616 17.5193 3.52965 17.4964 3.68465 17.4241L11.6672 13.7649Z"
        stroke="currentColor"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function EventOffIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.9998 3H3L2.9998 4M9.4998 2L8.9998 4M15.9998 3H17.9998M16.9998 2V4M12.9998 7L11.9998 8M15.9998 11L17.9998 10.5M15.9998 17H16.9998V18M1 1L19 19M11.9998 14.518L5.4818 8L1.0918 17.58C1.00504 17.766 0.977602 17.9742 1.01323 18.1763C1.04885 18.3785 1.14581 18.5647 1.29094 18.7099C1.43607 18.855 1.62234 18.952 1.82447 18.9876C2.02661 19.0232 2.2348 18.9958 2.4208 18.909L11.9998 14.518Z"
        stroke="currentColor"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function EventAddIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.9998 5H5.9998M4.9998 4V6M11.4998 4L10.9998 6M17.9998 5H19.9998M18.9998 4V6M14.9998 9L13.9998 10M16.9998 19H22.9998M19.9998 16V22M13.9998 16.518L7.4818 10L3.0918 19.58C3.00504 19.766 2.9776 19.9742 3.01323 20.1763C3.04885 20.3785 3.14581 20.5647 3.29094 20.7099C3.43607 20.855 3.62234 20.952 3.82447 20.9876C4.02661 21.0232 4.2348 20.9958 4.4208 20.909L13.9998 16.518Z"
        stroke="currentColor"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
